/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import { utils, Contract, ContractFactory } from "ethers";
const _abi = [
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "previousAdmin",
                type: "address",
            },
            {
                indexed: false,
                internalType: "address",
                name: "newAdmin",
                type: "address",
            },
        ],
        name: "AdminChanged",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "beacon",
                type: "address",
            },
        ],
        name: "BeaconUpgraded",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "oldContract",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "newContract",
                type: "address",
            },
        ],
        name: "ContractUpgraded",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "implementation",
                type: "address",
            },
        ],
        name: "Upgraded",
        type: "event",
    },
    {
        inputs: [],
        name: "WETH",
        outputs: [
            {
                internalType: "contract IWETH",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint16",
                name: "chainId_",
                type: "uint16",
            },
        ],
        name: "bridgeContracts",
        outputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "chainId",
        outputs: [
            {
                internalType: "uint16",
                name: "",
                type: "uint16",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "hash",
                type: "bytes32",
            },
        ],
        name: "governanceActionIsConsumed",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "governanceChainId",
        outputs: [
            {
                internalType: "uint16",
                name: "",
                type: "uint16",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "governanceContract",
        outputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "impl",
                type: "address",
            },
        ],
        name: "isInitialized",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "hash",
                type: "bytes32",
            },
        ],
        name: "isTransferCompleted",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "token",
                type: "address",
            },
        ],
        name: "isWrappedAsset",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "token",
                type: "address",
            },
        ],
        name: "outstandingBridged",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes",
                name: "encoded",
                type: "bytes",
            },
        ],
        name: "parseRegisterChain",
        outputs: [
            {
                components: [
                    {
                        internalType: "bytes32",
                        name: "module",
                        type: "bytes32",
                    },
                    {
                        internalType: "uint8",
                        name: "action",
                        type: "uint8",
                    },
                    {
                        internalType: "uint16",
                        name: "emitterChainID",
                        type: "uint16",
                    },
                    {
                        internalType: "bytes32",
                        name: "emitterAddress",
                        type: "bytes32",
                    },
                ],
                internalType: "struct BridgeStructs.RegisterChain",
                name: "chain",
                type: "tuple",
            },
        ],
        stateMutability: "pure",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes",
                name: "encoded",
                type: "bytes",
            },
        ],
        name: "parseUpgrade",
        outputs: [
            {
                components: [
                    {
                        internalType: "bytes32",
                        name: "module",
                        type: "bytes32",
                    },
                    {
                        internalType: "uint8",
                        name: "action",
                        type: "uint8",
                    },
                    {
                        internalType: "bytes32",
                        name: "newContract",
                        type: "bytes32",
                    },
                ],
                internalType: "struct BridgeStructs.UpgradeContract",
                name: "chain",
                type: "tuple",
            },
        ],
        stateMutability: "pure",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes",
                name: "encodedVM",
                type: "bytes",
            },
        ],
        name: "registerChain",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "tokenImplementation",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes",
                name: "encodedVM",
                type: "bytes",
            },
        ],
        name: "upgrade",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "wormhole",
        outputs: [
            {
                internalType: "contract IWormhole",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint16",
                name: "tokenChainId",
                type: "uint16",
            },
            {
                internalType: "bytes32",
                name: "tokenAddress",
                type: "bytes32",
            },
        ],
        name: "wrappedAsset",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        stateMutability: "payable",
        type: "receive",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "tokenAddress",
                type: "address",
            },
            {
                internalType: "uint32",
                name: "nonce",
                type: "uint32",
            },
        ],
        name: "attestToken",
        outputs: [
            {
                internalType: "uint64",
                name: "sequence",
                type: "uint64",
            },
        ],
        stateMutability: "payable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint16",
                name: "recipientChain",
                type: "uint16",
            },
            {
                internalType: "bytes",
                name: "recipient",
                type: "bytes",
            },
            {
                internalType: "uint256",
                name: "arbiterFee",
                type: "uint256",
            },
            {
                internalType: "uint32",
                name: "nonce",
                type: "uint32",
            },
        ],
        name: "wrapAndTransferETH",
        outputs: [
            {
                internalType: "uint64",
                name: "sequence",
                type: "uint64",
            },
        ],
        stateMutability: "payable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "token",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
            {
                internalType: "uint16",
                name: "recipientChain",
                type: "uint16",
            },
            {
                internalType: "bytes",
                name: "recipient",
                type: "bytes",
            },
            {
                internalType: "uint256",
                name: "arbiterFee",
                type: "uint256",
            },
            {
                internalType: "uint32",
                name: "nonce",
                type: "uint32",
            },
        ],
        name: "transferTokens",
        outputs: [
            {
                internalType: "uint64",
                name: "sequence",
                type: "uint64",
            },
        ],
        stateMutability: "payable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes",
                name: "encodedVm",
                type: "bytes",
            },
        ],
        name: "updateWrapped",
        outputs: [
            {
                internalType: "address",
                name: "token",
                type: "address",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes",
                name: "encodedVm",
                type: "bytes",
            },
        ],
        name: "createWrapped",
        outputs: [
            {
                internalType: "address",
                name: "token",
                type: "address",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes",
                name: "encodedVm",
                type: "bytes",
            },
        ],
        name: "completeTransfer",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes",
                name: "encodedVm",
                type: "bytes",
            },
        ],
        name: "completeTransferAndUnwrapETH",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                components: [
                    {
                        internalType: "uint8",
                        name: "payloadID",
                        type: "uint8",
                    },
                    {
                        internalType: "bytes32",
                        name: "tokenAddress",
                        type: "bytes32",
                    },
                    {
                        internalType: "uint16",
                        name: "tokenChain",
                        type: "uint16",
                    },
                    {
                        internalType: "uint8",
                        name: "decimals",
                        type: "uint8",
                    },
                    {
                        internalType: "bytes32",
                        name: "symbol",
                        type: "bytes32",
                    },
                    {
                        internalType: "bytes32",
                        name: "name",
                        type: "bytes32",
                    },
                ],
                internalType: "struct BridgeStructs.AssetMeta",
                name: "meta",
                type: "tuple",
            },
        ],
        name: "encodeAssetMeta",
        outputs: [
            {
                internalType: "bytes",
                name: "encoded",
                type: "bytes",
            },
        ],
        stateMutability: "pure",
        type: "function",
    },
    {
        inputs: [
            {
                components: [
                    {
                        internalType: "uint8",
                        name: "payloadID",
                        type: "uint8",
                    },
                    {
                        internalType: "uint256",
                        name: "amount",
                        type: "uint256",
                    },
                    {
                        internalType: "bytes32",
                        name: "tokenAddress",
                        type: "bytes32",
                    },
                    {
                        internalType: "uint16",
                        name: "tokenChain",
                        type: "uint16",
                    },
                    {
                        internalType: "bytes",
                        name: "to",
                        type: "bytes",
                    },
                    {
                        internalType: "uint256",
                        name: "fee",
                        type: "uint256",
                    },
                ],
                internalType: "struct BridgeStructs.Transfer",
                name: "transfer",
                type: "tuple",
            },
        ],
        name: "encodeTransfer",
        outputs: [
            {
                internalType: "bytes",
                name: "encoded",
                type: "bytes",
            },
        ],
        stateMutability: "pure",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes",
                name: "encoded",
                type: "bytes",
            },
        ],
        name: "parseAssetMeta",
        outputs: [
            {
                components: [
                    {
                        internalType: "uint8",
                        name: "payloadID",
                        type: "uint8",
                    },
                    {
                        internalType: "bytes32",
                        name: "tokenAddress",
                        type: "bytes32",
                    },
                    {
                        internalType: "uint16",
                        name: "tokenChain",
                        type: "uint16",
                    },
                    {
                        internalType: "uint8",
                        name: "decimals",
                        type: "uint8",
                    },
                    {
                        internalType: "bytes32",
                        name: "symbol",
                        type: "bytes32",
                    },
                    {
                        internalType: "bytes32",
                        name: "name",
                        type: "bytes32",
                    },
                ],
                internalType: "struct BridgeStructs.AssetMeta",
                name: "meta",
                type: "tuple",
            },
        ],
        stateMutability: "pure",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes",
                name: "encoded",
                type: "bytes",
            },
        ],
        name: "parseTransfer",
        outputs: [
            {
                components: [
                    {
                        internalType: "uint8",
                        name: "payloadID",
                        type: "uint8",
                    },
                    {
                        internalType: "uint256",
                        name: "amount",
                        type: "uint256",
                    },
                    {
                        internalType: "bytes32",
                        name: "tokenAddress",
                        type: "bytes32",
                    },
                    {
                        internalType: "uint16",
                        name: "tokenChain",
                        type: "uint16",
                    },
                    {
                        internalType: "bytes",
                        name: "to",
                        type: "bytes",
                    },
                    {
                        internalType: "uint256",
                        name: "fee",
                        type: "uint256",
                    },
                ],
                internalType: "struct BridgeStructs.Transfer",
                name: "transfer",
                type: "tuple",
            },
        ],
        stateMutability: "pure",
        type: "function",
    },
];
const _bytecode = "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";
export class Bridge__factory extends ContractFactory {
    constructor(signer) {
        super(_abi, _bytecode, signer);
    }
    deploy(overrides) {
        return super.deploy(overrides || {});
    }
    getDeployTransaction(overrides) {
        return super.getDeployTransaction(overrides || {});
    }
    attach(address) {
        return super.attach(address);
    }
    connect(signer) {
        return super.connect(signer);
    }
    static createInterface() {
        return new utils.Interface(_abi);
    }
    static connect(address, signerOrProvider) {
        return new Contract(address, _abi, signerOrProvider);
    }
}
Bridge__factory.bytecode = _bytecode;
Bridge__factory.abi = _abi;
